import React, { useState, useEffect, useContext, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import "./Footer.css";
import Slider from "react-slick";
// import { Container, Row, Col, Table } from "react-bootstrap";
import URLstateContext from "../../provider/CommonContext";
import { Container, Row, Col } from "react-bootstrap";


const TabFooter = () => {
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup;
    let PageSize = 8;
    const [activeIndex, setActiveIndex] = useState(null);
    let arrayData = [];
    const [val,setval]=useState(false);
    const [val1,setval1]=useState(false);
    const [val2,setval2]=useState(false);
    const [val3,setval3]=useState(false);
    const [val4,setval4]=useState(false);
    const [val5,setval5]=useState(false);

    useEffect(() => {
        // if (groupValue === "BSE") {       
        const getUrl = BaseURL + "stocklist";
        fetch(`${getUrl}/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                // console.log(getData, "getData")
            })
            .catch((error) => {
            });

    }, []);

    const chunkSize = 10;
    const chunks = [];
    for (let i = 0; i < data.length; i += chunkSize) {
        chunks.push(data.slice(i, i + chunkSize));
    }

    const datafooter = [
        {
            headerfooter: "Stock",
        },

        {
            headerfooter: "Equity",
            submenufooter: [

                {
                    url: "https://www.moneysukh.com/market/stocks",
                    title: "Daily Market Tracker",
                },
                {
                    url: "https://www.moneysukh.com/MarketEquity/Chart-Intraday-Sensex",
                    title: "Chart-Intraday Sensex",
                },
                {
                    url: "https://www.moneysukh.com/MarketEquity/Gainers-and-Losers",
                    title: "Gainers & Losers",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/52-Week-High-Low",
                    title: "52 Week High / Low",
                },
                {
                    url: "https://www.moneysukh.com/MarketEquity/Advance-and-Decline",
                    title: "Advances & Declines",
                },
                {
                    url: "https://www.moneysukh.com/MarketEquity/New-High-Low",
                    title: "New High And Low",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Value-Volume-Toppers",
                    title: "Value / Volume Toppers",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Out-Under-Performers",
                    title: "Out / Under Performers",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Only-Buyers-Sellers",
                    title: "Only Buyers/Sellers",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Unusual-Volume",
                    title: "Unusual Volume",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Exchange-Holidays",
                    title: "Exchange Holidays",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Bulk-Deals",
                    title: "Bulk Deals",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Block-Deals",
                    title: "Block Deals",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Index-Constituents",
                    title: "Index Constituents",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Historical-Returns",
                    title: "Historical Return",
                },



            ],
            submenufooter1: [
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Company Profile",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Company Background",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Board Of Directors",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Balance Sheet",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Profit And Loss",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Quarterly Results",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Key Financial Ratios",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Share Price",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Intraday / EOD Charts",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Cash Flow",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Company Snapshort",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Share Holding Pattern",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Directors Report",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "MF Holdings",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Name Change",
                },



            ],
            submenufooter2: [
                {
                    url: "https://www.moneysukh.com/market/stocks",
                    title: "CM Live News",
                },
                {
                    url: "https://www.moneysukh.com/CompanyNews/Hot-Pursuit",
                    title: "Hot Pursuit",
                },
                {
                    url: "https://www.moneysukh.com/CompanyNews/Pre-Session-Commentary",
                    title: "PRE-SESSION COMMENTARY",
                },

                {
                    url: "https://www.moneysukh.com/CompanyNews/Mid-Session-Commentary",
                    title: "MID-SESSION COMMENTARY",
                },
                {
                    url: "https://www.moneysukh.com/CompanyNews/End-Session-Commentary",
                    title: "End-Session Commentary",
                },
                {
                    url: "https://www.moneysukh.com/CompanyNews/Corporate-News",
                    title: "Corporate News",
                },

                {
                    url: "https://www.moneysukh.com/CompanyNews/Market-Beat",
                    title: "MARKET BEAT",
                },

                {
                    url: "https://www.moneysukh.com/CompanyNews/Economy-News",
                    title: "ECONOMY NEWS",
                },
                {
                    url: "https://www.moneysukh.com/CompanyNews/Other-Markets-News",
                    title: "Other Markets",
                },
                {
                    url: "https://www.moneysukh.com/CompanyNews/Corporate-Results",
                    title: "Corporate Results",
                },

                {
                    url: "https://www.moneysukh.com/CompanyNews/Stock-Alert",
                    title: "Stock Alert",
                },
                {
                    url: "https://www.moneysukh.com/MarketEquity/Live-Indices",
                    title: "Live Indices",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Rising-VDP",
                    title: "Rising VDP",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/Rising-Volume-Delivery-Fall-In-Price",
                    title: "Rising Volume, Delivery & Fall in Price",
                },

                {
                    url: "https://www.moneysukh.com/MarketEquity/5-Days-Up-Down",
                    title: "5 Days Up / Down",
                },


            ],
            submenufooter3: [
                {
                    url: "https://www.moneysukh.com/market/stocks",
                    title: "Corporate Announcements",
                },
                {
                    url: "https://www.moneysukh.com/CorporateAction/Daily-Announcements",
                    title: "Daily Announcement",
                },
                {
                    url: "https://www.moneysukh.com/CorporateAction/Board-Meetings",
                    title: "BOARD MEETINGS",
                },

                {
                    url: "https://www.moneysukh.com/CorporateAction/Book-Closure",
                    title: "BOOK CLOSURE",
                },
                {
                    url: "https://www.moneysukh.com/CorporateAction/Bonus",
                    title: "Bonus Issues",
                },
                {
                    url: "https://www.moneysukh.com/CorporateAction/BuyBack-List",
                    title: "BuyBack List",
                },

                {
                    url: "https://www.moneysukh.com/CorporateAction/Dividend",
                    title: "Dividend",
                },

                {
                    url: "https://www.moneysukh.com/CorporateAction/Rights",
                    title: "RIGHTS ISSUES",
                },

                {
                    url: "https://www.moneysukh.com/CorporateAction/De-listed-Shares",
                    title: "Delisted Shares",
                },
                {
                    url: "https://www.moneysukh.com/CorporateAction/Market-Turnover",
                    title: "Market TurnOver",
                },
                {
                    url: "https://www.moneysukh.com/CorporateAction/Change-Name",
                    title: "Name Change",
                },
                {
                    url: "https://www.moneysukh.com/CorporateAction/Split-Face-Value",
                    title: "Face Value",
                },
                {
                    url: "https://www.moneysukh.com/CompanyNews/Futures-Market",
                    title: "Futures Market",
                },
                {
                    url: "https://www.moneysukh.com/CompanyNews/Foreign-Markets",
                    title: "Foreign Markets",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Company News",
                },
            ],
            submenufooter4: [

                // headerfooter: "Other Market Info",
                // submenufooter: 

                {
                    url: "https://www.moneysukh.com/market/stocks",
                    title: "Other Market Info",
                },
                {
                    url: "https://www.moneysukh.com/OtherMarket/FII-Investment",
                    title: "FII Investment",
                },
                {
                    url: "https://www.moneysukh.com/OtherMarket/MF-Investment",
                    title: "MFI Investment",
                },

                {
                    url: "https://www.moneysukh.com/OtherMarket/World-Indices",
                    title: "World Indices",
                },
                {
                    url: "https://www.moneysukh.com/OtherMarket/ADR-Prices",
                    title: "ADR Price",
                },
                {
                    url: "https://www.moneysukh.com/OtherMarket/Forex",
                    title: "Forex Details",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Announcements",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Board Meetings",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Book Closure",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Peer Comparison",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Bonus",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Dividend",
                },
                {
                    url: "https://www.moneysukh.com/CompanyProfile/Get-Quotes",
                    title: "Rights",
                },
                {
                    url: "https://learn.moneysukh.com/top-factors-affecting-the-stock-market-in-india/",
                    title: "Top Factors Affecting the Stock Market",
                },


            ],

        },
        {
            headerfooter: "IPO",
            submenufooter: [
                {
                    title: "",
                },
                {
                    url: "https://www.moneysukh.com/market/ipo",
                    title: "IPO",
                },
                {
                    url: "https://www.moneysukh.com/IPO/Forthcoming-IPO",
                    title: "Forthcoming IPO",
                },
                {
                    url: "https://www.moneysukh.com/IPO/Open-IPO",
                    title: "Open IPO",
                },
                {
                    url: "https://www.moneysukh.com/IPO/Closed-IPO",
                    title: "Closed IPO",
                },

                {
                    url: "https://www.moneysukh.com/IPO/New-Listing",
                    title: "New Listing",
                },
                {
                    url: "https://www.moneysukh.com/IPO/IPO-News",
                    title: "IPO News",
                },
                {
                    url: "https://www.moneysukh.com/IPO/Basis-Of-Allotment",
                    title: "Basis of Allotment",
                },
                {
                    url: "https://www.moneysukh.com/IPO/Draft-Prospectus",
                    title: "Draft Prospectus",
                },
                {
                    url: "https://learn.moneysukh.com/first-cry-brainbees-ipo-details-date-price-size-gmp/",
                    title: "FirstCry IPO Detail",
                },
               

            ],
            submenufooter1: [
                {
                    title: "",
                },
                {
                    url: "https://www.moneysukh.com/IPO/Best-Performers",
                    title: "Best Performers",
                },
                {
                    url: "https://learn.moneysukh.com/rr-kabel-ipo-details-launch-date-price-size-gmp/",
                    title: "RR Kabel IPO",
                },
                {
                    url: "https://learn.moneysukh.com/reliance-retail-ipo-details-date-allotment-status-updates-issue-price-gmp-review/",
                    title: "Reliance Retail IPO",
                },
                {
                    url: "https://learn.moneysukh.com/tata-technologies-ipo-details-date-allotment-status-updates-issue-price-gmp-review/",
                    title: "Tata Technologies IPO",
                },
                {
                    url: "https://learn.moneysukh.com/gandhar-oil-ipo-update-date-price-gmp-review/",
                    title: "Gandhar Oil IPO",
                },
                
                {
                    url: "https://learn.moneysukh.com/sbfc-ipo-details-launch-date-share-price-size-gmp-review/",
                    title: "SBFC IPO",
                },
                {
                    url: "https://learn.moneysukh.com/nsdl-ipo-details-launch-date-price-size-gmp/",
                    title: "NSDL IPO Details",
                },
                {
                    url: "https://learn.moneysukh.com/cello-world-ipo-details-launch-date-price-size-gmp/",
                    title: "Cello World IPO",
                },
                {
                    url: "https://learn.moneysukh.com/ola-electric-ipo-details-launch-date-price-size-gmp/",
                    title: "Ola Electric IPO Detail",
                },
               
            ],
            submenufooter2: [
                {
                    title: "",
                },
                    // {
                //     url: "https://learn.moneysukh.com/sterlite-power-transmission-ipo-date-price-gmp-review/",
                //     title: "Sterlite power transmission IPO",
                // },
                {
                    url: "https://learn.moneysukh.com/hero-fincorp-ipo-details-date-issue-price-gmp-review/",
                    title: "Hero fincorp IPO",
                },
                {
                    url: "https://learn.moneysukh.com/ebixcash-ipo-details-date-allotment-status-updates-issue-price-gmp-review/",
                    title: "Ebixcash IPO",
                },
                // {
                //     url: "https://learn.moneysukh.com/reliance-retail-ipo-details-date-allotment-status-updates-issue-price-gmp-review/",
                //     title: "Reliance retail IPO",
                // },
                {
                    url: "https://learn.moneysukh.com/yatharth-hospital-ipo-price-date-gmp-review/",
                    title: "Yatharth hospital IPO",
                },
                {
                    url: "https://learn.moneysukh.com/vlcc-healthcare-ipo-details-date-allotment-status-updates-issue-price-gmp-review/",
                    title: "VLCC Healthcare IPO",
                },
                {
                    url: "https://learn.moneysukh.com/imagine-marketing-boat-ipo-date-price-size-gmp/",
                    title: "Flair Writing Industries IPO",
                },
                {
                    url: "https://learn.moneysukh.com/jsw-infrastructure-ipo-date-price-size-gmp/",
                    title: "JSW Infrastructure IPO",
                },
                
                {
                    url: "https://learn.moneysukh.com/go-airlines-ipo-details-lot-size-gmp-allotment-status/",
                    title: "Go Airlines IPO",
                },
                {
                    url: "https://learn.moneysukh.com/how-to-apply-for-ipo-in-hni-benefits-procedure/",
                    title: "How to Apply for IPO",
                },
                {
                    url: "https://learn.moneysukh.com/emcure-pharmaceuticals-ipo-details-date-price-size-gmp/",
                    title: "Emcure Pharmaceuticals IPO Detail",
                },
               
                
            ],
            submenufooter3: [
                {
                    title: "",
                },
                {
                    url: "https://learn.moneysukh.com/what-is-drhp-in-ipo-how-to-read-difference-with-rhp/",
                    title: "What is DRHP in IPO",
                },
                {
                    url: "https://learn.moneysukh.com/sai-silks-ipo-details-launch-date-price-size-gmp/",
                    title: "Sai Silks Kalamandir IPO",
                },
                {
                    url: "https://learn.moneysukh.com/mankind-pharma-ipo-details-date-allotment-status-updates-issue-price-gmp-review/",
                    title: "Mankind Pharma IPO",
                },
                {
                    url: "https://learn.moneysukh.com/utkarsh-ipo-update-launch-date-issue-price-gmp-review/",
                    title: "Utkarsh IPO",
                },
                {
                    url: "https://learn.moneysukh.com/snapdeal-limited-ipo-details-date-issue-price-gmp-review/",
                    title: "Snapdeal Limited IPO",
                },
                {
                    url: "https://learn.moneysukh.com/fincare-small-finance-bank-ipo-date-price-gmp/",
                    title: "Fincare Small Finance Bank IPO",
                },
                {
                    url: "https://learn.moneysukh.com/vikram-solar-ipo-details-date-price-size-gmp/",
                    title: "Vikram Solar IPO",
                },
                {
                    url: "https://learn.moneysukh.com/sterlite-power-transmission-ipo-date-price-gmp-review/",
                    title: "Sterlite Power Transmission IPO",
                },
                {
                    url: "https://learn.moneysukh.com/bharti-hexacom-ipo-details-date-price-size-gmp/",
                    title: "Bharti Hexacom IPO Details",
                },
                
            ],
            submenufooter4: [
                {
                    title: "",
                },
               
                {
                    url: "https://learn.moneysukh.com/what-to-check-before-buying-ipo-things-to-know/",
                    title: "What to Check Before Subscribing IPO",
                },
               
                {
                    url: "https://learn.moneysukh.com/tvs-supply-chain-solutions-ipo-details-date-allotment-status-updates-issue-price-gmp-review/",
                    title: "TVS Supply Chain Solutions IPO",
                },
                {
                    url: "https://learn.moneysukh.com/western-carriers-india-ipo-date-price-size-gmp/",
                    title: "Western Carriers (India) Limited IPO",
                },
                {
                    url: "https://learn.moneysukh.com/gemini-edibles-fats-ipo-date-price-size-gmp/",
                    title: "Gemini Edibles & Fats India IPO",
                },
                {
                    url: "https://learn.moneysukh.com/one-mobikwik-ipo-details-launch-date-price-size-gmp/",
                    title: "One Mobikwik IPO Detail",
                },
                {
                    url: "https://learn.moneysukh.com/allied-blenders-distillers-ipo-details-date-price-size-gmp/",
                    title: "Allied Blenders and Distillers IPO",
                },
               
                {
                    url: "https://learn.moneysukh.com/northern-arc-capital-ipo-details-date-price-size-gmp/",
                    title: "Northern Arc Capital IPO Details",
                },
                {
                    url: "https://learn.moneysukh.com/bansal-wire-industries-ipo-details-date-price-size-gmp/",
                    title: "Bansal Wire Industries IPO Details",
                },
                {
                    url: "https://learn.moneysukh.com/how-to-improve-allotment-chances-tips-investing-ipo/",
                    title: "How to improve Allotment chances",
                },
                
               
               
                // {
                //     url: "https://learn.moneysukh.com/flair-writing-industries-ipo-date-price-size-gmp/",
                //     title: "Flair Writing Industries IPO",
                // },
            ],
        },
        
        {
            headerfooter: "Mutual Fund",
            submenufooter: [
                {
                    url: "https://www.moneysukh.com/market/mutual-funds",
                    title: "Mutual Fund",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/Fund-Profile",
                    title: "Fund Profile",
                },
                {
                    url: "https://www.moneysukh.com/SchemeSnapshot/Aditya_Birla_SL_Arbitrage_Fund_(G)",
                    title: "Scheme Profile",
                },

                {
                    url: "https://www.moneysukh.com/MutualFund/Fund-Performance",
                    title: "Fund Performance",
                },
                {
                    url: "https://www.moneysukh.com/Mutual-Fund-SIP-Calculator",
                    title: "SIP Calculator",
                },


            ],
            submenufooter1: [
                {
                    title: "",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/New-Fund-Offer",
                    title: "New Fund Offer",
                },

                {
                    url: "https://www.moneysukh.com/MutualFund/Daily-NAV",
                    title: "Daily Nav",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/Least-Volatile-Schemes",
                    title: "Least Volatile Scheme",
                },
            ],
            submenufooter2: [
                {
                    title: "",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/Mutual-Fund-News",
                    title: "MF News",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/Historical-NAv",
                    title: "Historical Nav",
                },

                {
                    url: "https://www.moneysukh.com/MutualFund/Scheme-Comparison",
                    title: "Scheme Comparison",
                },
            ],
            submenufooter3: [
                {
                    title: "",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/MF-Synopsis",
                    title: "MF Synopsis",
                },

                {
                    url: "https://www.moneysukh.com/MutualFund/Dividend-Details",
                    title: "Dividend Details",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/Category-Return",
                    title: "Category Returns",
                },
            ],
            submenufooter4: [
                {
                    title: "",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/Mutual-Fund-Activities",
                    title: "MF Activities",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/Top-10-Holding",
                    title: "Top 10 Holdings",
                },
                {
                    url: "https://www.moneysukh.com/MutualFund/What's-In-and-Out",
                    title: "What’s In /Out",
                },
            ],
        },
        {
            headerfooter: "F & O",
            submenufooter: [
                {
                    url: "https://www.moneysukh.com/market/futures-and-options",
                    title: "Derivative",
                },
                {
                    url: "https://www.moneysukh.com/Futures-And-Options/Nifty-Futures",
                    title: "Nifty Futures",
                },
                {
                    url: "https://www.moneysukh.com/Futures-And-Options/Derivative-Summary",
                    title: "Derivative Summary",
                },

                {
                    url: "https://www.moneysukh.com/Futures-And-Options/FII-Statistics",
                    title: "FII Statistics",
                },
                {
                    url: "https://www.moneysukh.com/Futures-And-Options/List-of-underlying-Securities",
                    title: "List Of Underlyings",
                },
                {
                    url: "https://www.moneysukh.com/Futures-And-Options/Top-Quantity",
                    title: "Top Quantity",
                },

                {
                    url: "https://www.moneysukh.com/Futures-And-Options/Put-Call-Ratio",
                    title: "Put Call Ratio",
                },

                {
                    url: "https://www.moneysukh.com/Futures-And-Options/Cost-of-Carry",
                    title: "Cost Of Carry",
                },
                {
                    url: "https://www.moneysukh.com/Futures-And-Options/Position-Limit",
                    title: "Position Limit",
                },
                {
                    url: "https://www.moneysukh.com/Futures-And-Options/Roll-Over",
                    title: "Roll Over",
                },
                {
                    url: "https://www.moneysukh.com/Futures-And-Options/Derivative-News",
                    title: "Derivative News",
                },
            ],
            submenufooter1: [

                {
                    url: "https://www.moneysukh.com/market/futures-and-options",
                    title: "Future",
                },
                {
                    url: "/Futures-And-Options/Most-Active-Contracts",
                    title: "Most Active Contracts",
                },
                {
                    url: "/Futures-And-Options/All-Index-Future",
                    title: "All Index Future",
                },
                {
                    url: "/Futures-And-Options/Top-Gainers-Futures",
                    title: "Top Gainer",
                },
                {
                    url: "/Futures-And-Options/Top-Losers-Futures",
                    title: "TOP LOSERS",
                },
                {
                    url: "/Futures-And-Options/Highest-in-OI-Futures",
                    title: "Highest In OI",
                },
                {
                    url: "/Futures-And-Options/Lowest-in-OI-Futures",
                    title: "Lowest In OI",
                },
                {
                    url: "/Futures-And-Options/Increase-in-OI-Futures",
                    title: "Increase In OI In%",
                },
                {
                    url: "/Futures-And-Options/Decrease-in-OI-Futures",
                    title: "Decrease In OI In%",
                },


            ],
            submenufooter2: [

                {
                    url: "https://www.moneysukh.com/market/futures-and-options",
                    title: "Options",
                },
                {
                    url: "/Futures-And-Options/Most-Active-Call",
                    title: "Most Active Call",
                },
                {
                    url: "/Futures-And-Options/Most-Active-Put",
                    title: "Most Active Put",
                },
                {
                    url: "/Futures-And-Options/Top-Gainers-Options",
                    title: "Top Gainers",
                },
                {
                    url: "/Futures-And-Options/Top-Losers-Options",
                    title: "Top Losers",
                },
                {
                    url: "/Futures-And-Options/Highest-in-OI-Options",
                    title: "Highest In OI",
                },
                {
                    url: "/Futures-And-Options/Lowest-in-OI-Options",
                    title: "Lowest In OI",
                },
                {
                    url: "/Futures-And-Options/Increase-in-OI-Options",
                    title: "Increase In OI",
                },
                {
                    url: "/Futures-And-Options/Decrease-in-OI-Options",
                    title: "Decrease In OI",
                },

            ],
            submenufooter3: [
                {
                    title: "Blog",
                },
                {
                    url: "https://learn.moneysukh.com/bearish-and-range-bound-option-strategies/",
                    title: "Bearish Option Strategies",
                },  
                {
                    url: "https://learn.moneysukh.com/vix-india/",
                    title: "India Vix",
                },  
                {
                    url: "https://learn.moneysukh.com/equity-commodity-which-is-better-for-trading/",
                    title: "Equity or Commodity which is better",
                },  
                {
                    url: "https://learn.moneysukh.com/neutral-options-strategies-for-trading/",
                    title: "Bullish option Strategies",
                },  
                {
                    url: "https://learn.moneysukh.com/short-straddle-and-short-strangle-option-strategy/",
                    title: "Short straddle and short strangle",
                },  
                {
                    url: "https://learn.moneysukh.com/neutral-options-strategies-for-trading/",
                    title: "Neutral Options Strategies for Trading",
                },  
                {
                    url: "https://learn.moneysukh.com/option-buying-vs-option-selling/",
                    title: "Option buying vs Option selling",
                },  
                {
                    url: "https://learn.moneysukh.com/nse-option-chain-analysis-how-it-works-what-does-indicate/",
                    title: "NSE Option Chain Analysis",
                },  
            ],
            submenufooter4: [
            ],
        },
        
      
        {
            headerfooter: "Other Links",

            submenufooter: [

                {

                    title: "Blogs",
                },
                {
                    url: "https://learn.moneysukh.com/best-intraday-algo-strategy/",
                    title: "Best intraday algo strategy"
                    ,
                },
                {
                    url: "https://learn.moneysukh.com/what-is-profit-booking-in-stock-market-rules-strategy/",
                    title: "What is profit booking",
                },
                {
                    url: "https://learn.moneysukh.com/what-is-long-unwinding-in-stock-market/",
                    title: "What is long unwinding",
                },
                {
                    url: "https://learn.moneysukh.com/usd-inr-options-trading-strategies-beginners-guide-to-trade/",
                    title: "Options trading strategies",
                },
                {
                    url: "https://learn.moneysukh.com/nse-option-chain-analysis-how-it-works-what-does-indicate/",
                    title: "Option chain analysis",
                },
                {
                    url: "https://learn.moneysukh.com/what-is-heat-map-in-stock-market-how-heatmap-works-used/",
                    title: "What is heat map",
                },
                {
                    url: "https://learn.moneysukh.com/candlestick-chart-patterns/",
                    title: "Candlestick chart patterns",
                },
                {
                    url: "https://learn.moneysukh.com/best-algo-trading-platform-and-trading-strategies/",
                    title: "Best algo trading platform",
                },
                {
                    url: "https://learn.moneysukh.com/nifty-open-interest-change-in-nifty-oi-for-data-analysis/",
                    title: "Nifty open interest change",
                },
                {
                    url: "https://learn.moneysukh.com/trading-or-investing-which-is-better-more-profitable/",
                    title: "Trading or investing which is better",
                },
                {
                    url: "https://learn.moneysukh.com/nse-option-chain-analysis-how-it-works-what-does-indicate/",
                    title: "NSE Option Chain Analysis",
                },
                {
                    url: "https://learn.moneysukh.com/usd-inr-options-trading-strategies-beginners-guide-to-trade/",
                    title: "USD INR Options Trading Strategies",
                },
                {
                    url: "https://learn.moneysukh.com/most-popular-profitable-algo-trading-strategies/",
                    title: "Most Popular & Profitable Algo Trading Strategies",
                },
                {
                    url: "https://learn.moneysukh.com/advantages-and-disadvantages-of-forex-trading/",
                    title: "Advantages and Disadvantages of Forex Trading",
                },
                {
                    url: "https://learn.moneysukh.com/best-volume-indicators-for-day-trading-intraday/",
                    title: "Best Volume Indicators for Day Trading",
                },
                {
                    url: "https://learn.moneysukh.com/best-stock-to-buy-in-2024/",
                    title: "Best Stock to Buy in 2024",
                },
                {
                    url: "https://learn.moneysukh.com/weekly-option-strategy-short-iron-condor-option-strategy/",
                    title: "Nifty Weekly Expiry Strategy",
                },
                {
                    url: "https://learn.moneysukh.com/best-indicator-for-swing-trading/",
                    title: "Best indicator for swing trading",
                },
                {
                    url: "https://learn.moneysukh.com/discount-broker-vs-full-service-broker-difference/",
                    title: "Discount Broker vs Full Service Broker",
                },
                {
                    url: "https://learn.moneysukh.com/best-most-profitable-forex-trading-strategies/",
                    title: "Most Profitable Forex Trading Strategie",
                },
                {
                    url: "https://learn.moneysukh.com/things-to-know-before-starting-forex-trading/",
                    title: "Things to Know Before Starting Forex Trading",
                },
                {
                    url: "https://learn.moneysukh.com/choosing-the-right-broker-decoding-the-mystery-of-lowest-brokerage-charges/",
                    title: "Decoding the mystery of lowest brokerage charges",
                },
                {
                    url: "https://learn.moneysukh.com/demat-account-lowest-brokerage-charges-india/",
                    title: "Features of Best Demat Account",
                },
                {
                    url: "https://learn.moneysukh.com/maximize-your-profits-discover-the-benefits-of-low-brokerage-option-trading/",
                    title: "Discover the Benefits of Low Brokerage Option Trading",
                },
                {
                    url: "https://learn.moneysukh.com/benefits-of-minor-demat-account-empowering-the-next-generation-of-investors/",
                    title: "Benefits of Minor Demat account",
                },
                {
                    url: "https://learn.moneysukh.com/how-to-convert-physical-shares-into-demat/",
                    title: "How to Convert Physical Shares Into Demat",
                },
                {
                    url: "https://learn.moneysukh.com/the-ultimate-guide-to-finding-the-best-discount-broker-in-india-for-your-investment-needs/",
                    title: "Ultimate Guide to Finding the Best Discount Broker",
                },
                {
                    url: "https://learn.moneysukh.com/short-term-trading-v-s-intraday-trading-which-one-is-more-profitable/",
                    title: "Short Term trading v/s Intraday trading",
                },
                {
                    url: "https://learn.moneysukh.com/trading-account-definition-eligibility-criteria-and-features/",
                    title: "Trading Account: Definition, Eligibility Criteria and Features",
                },
            ],
            // submenufooter1: [
            //     {

            //         title: "Pricing",
            //     },
            //     {
            //         url: "https://www.moneysukh.com/Pricing",
            //         title: "Brokerage Pricing",
            //     },
            // ],


            	
            	
            	
            	
            	
            	
            	
            	
            	
            	
            	
            	
            	
            	
            	
        
            submenufooter1: [
                {

                    title: "Technical analysis",
                },
                {
                    url: "https://learn.moneysukh.com/candlestick-chart-patterns/",
                    title: "What are Candlestick Charts",
                },
                {
                    url: "https://learn.moneysukh.com/what-is-heat-map-in-stock-market-how-heatmap-works-used/",
                    title: "Heat Map in Stock Market",
                },
                {
                    url: "https://learn.moneysukh.com/candlesticks/",
                    title: "How to read Candlestick",
                },
                {
                    url: "https://learn.moneysukh.com/what-is-rsi-in-trading-how-rsi-works-formula-and-strategy/",
                    title: "RSI in Trading",
                },
                {
                    url: "https://learn.moneysukh.com/how-to-use-fibonacci-retracements-for-trading/",
                    title: "Fibonacci Retracement for Trading",
                },
                {
                    url: "https://learn.moneysukh.com/support-and-resistance/",
                    title: "Support and Resistance",
                },
                {
                    url: "https://learn.moneysukh.com/what-is-breakout-breakdown-how-to-identify-breakout-in-stocks/",
                    title: "Breakout & Breakdown",
                },
                {
                    url: "https://learn.moneysukh.com/what-is-tradingview-and-how-to-use-it-for-trading/",
                    title: "TradingView -How to Use",
                },
                {
                    url: "https://learn.moneysukh.com/chart-patterns/",
                    title: "Bullish/Bearish Chart Patterns",
                },
                {
                    url: "https://learn.moneysukh.com/what-is-upper-circuit-and-lower-circuit-in-share-market-sebi-rules/",
                    title: "Upper Circuit and Lower Circuit",
                },
                {
                    url: "https://learn.moneysukh.com/is-technical-analysis-useful-useless-enough-for-trading/",
                    title: "Is Technical Analysis Useful or Useless",
                },
                {
                    url: "https://learn.moneysukh.com/bollinger-bands-indicator-strategy-settings-analysis/",
                    title: "Bollinger Bands: Indicator, Strategy",
                },
                // {
                //     url: "https://learn.moneysukh.com/nifty-open-interest-change-in-nifty-oi-for-data-analysis/",
                //     title: "Nifty Open Interest",
                // },
                {
                    url: "https://learn.moneysukh.com/best-moving-averages-for-intraday-trading/",
                    title: "Best Moving Averages for Intraday",
                },
                {
                    url: "https://learn.moneysukh.com/best-most-used-indicators-in-tradingview/",
                    title: "Most Used Indicators in TradingView",
                },
                {
                    url: "https://learn.moneysukh.com/stop-loss-in-stock-market-best-strategy-profit/",
                    title: "Stop Loss in Stock Market",
                },
                {
                    url: "https://learn.moneysukh.com/how-to-use-rsi-indicator-in-tradingview-strategy/",
                    title: "How to Add & Use RSI Indicator in TradingView",
                },
                {
                    url: "https://learn.moneysukh.com/best-and-most-accurate-trend-reversal-indicators/",
                    title: "Best and most Accurate Trend Reversal Indicators",
                },
                {
                    url: "https://learn.moneysukh.com/how-to-add-remove-save-indicators-in-tradingview/",
                    title: "How to Add or Remove, Hide & Save Indicators in TradingView",
                },
                {
                    url: "https://learn.moneysukh.com/keev-best-algo-trading-platform/",
                    title: "Keev-Best Algo Trading Platform",
                },
                {
                    url: "https://learn.moneysukh.com/best-indicators-for-intraday-trading/",
                    title: "Best Indicators for Intraday Trading",
                },
                {
                    url: "https://learn.moneysukh.com/how-to-understand-chart-structure-tradingview/",
                    title: "How to Understand Chart Structure in TradingView",
                },
                
            ],
            submenufooter2: [
                {

                    title: "Support",
                },
                {
                    url: "https://support.moneysukh.com/poa/",
                    title: "Poa",
                },
                {
                    url: "https://support.moneysukh.com/account-closure/",
                    title: "Account Closure",
                },
                {
                    url: "https://support.moneysukh.com/profile-details/",
                    title: "Profile",
                },
                {
                    url: "https://support.moneysukh.com/nomination/",
                    title: "Nomination",
                },
                {
                    url: "https://support.moneysukh.com/account-opening-process/",
                    title: "Account Opening Process",
                },
                {
                    url: "https://support.moneysukh.com/edis-and-dis/",
                    title: "Edis And Dis",
                },
                {
                    url: "https://support.moneysukh.com/add-funds/",
                    title: "Add Funds ",
                },
                {
                    url: "https://support.moneysukh.com/withdraw-funds/",
                    title: "Withdraw Funds ",
                },
                {
                    url: "https://support.moneysukh.com/quarterly-settlement/",
                    title: "Quarterly Settlement ",
                },
                {
                    url: "https://support.moneysukh.com/holding-portfolio/",
                    title: "Holding Portfolio",
                },
                {
                    url: "https://support.moneysukh.com/bonus-share/",
                    title: "Bonus Share",
                },
                {
                    url: "https://support.moneysukh.com/buyback/",
                    title: "Buyback",
                },
                {
                    url: "https://support.moneysukh.com/tpin/",
                    title: "Tpin",
                },
                {
                    url: "https://support.moneysukh.com/order-types/",
                    title: "Order Types",
                },
                {
                    url: "https://support.moneysukh.com/dividend/",
                    title: "Dividend",
                },
                {
                    url: "https://support.moneysukh.com/order-placing/",
                    title: "Order Placing",
                },
                {
                    url: "https://support.moneysukh.com/order-status/",
                    title: "Order Status",
                },
                {
                    url: "https://support.moneysukh.com/order-rejection/",
                    title: "Order Rejection",
                },
                {
                    url: "https://support.moneysukh.com/square-off/",
                    title: "Square Off",
                },
                {
                    url: "https://support.moneysukh.com/stock-sip/",
                    title: "Stock Sip",
                },
                {
                    url: "https://support.moneysukh.com/sovereign-gold-bonds/",
                    title: "Sovereign Gold Bond",
                },
                {
                    url: "https://support.moneysukh.com/margin-pledge-unpledged/",
                    title: "Margin Pledge Unpledged",
                },
                {
                    url: "https://support.moneysukh.com/auto-square-off-charges/",
                    title: "Auto Square Off Charges",
                },
                {
                    url: "https://support.moneysukh.com/regulatory-and-government-charges/",
                    title: "Regulatory And Government Charges",
                },
                {
                    url: "https://support.moneysukh.com/penal-delayed-payment-charges/",
                    title: "Penal Delayed Payment Charges",
                },
                {
                    url: "https://support.moneysukh.com/dp-charges/",
                    title: "Dp Charges",
                },
            ],
            
            submenufooter3: [
                
                
            ],
            submenufooter4: [
                    
                ],
        },
      
    ];
    const toggleList = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    }

     
        const settings = {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        };

    return (
        <>
            <div className="tabfooterhead">
                <div className="tab-footer-links">
                    {/* <Slider  {...settings}> */}
                    <div className="mainFooterDiv" tabIndex={0}>
                        <p className="fontfooter" onClick={() => {toggleList(0);
                            setval(false);
                            setval1(false);
                            setval2(false);
                            setval3(false);
                            setval4(false);
                            setval5(false);
                        
                        }} >{datafooter[0].headerfooter}  {activeIndex === 0 ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}</p>
                    </div>
                    <div className="mainFooterDiv" tabIndex={0}>
                        <p className="fontfooter" onClick={() => {toggleList(1);
                            setval(false);
                            setval1(false);
                            setval2(false);
                            setval3(false);
                            setval5(false);

                            setval4(false);}} >{datafooter[1].headerfooter}  {activeIndex === 1 ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}</p>
                    </div>
                    <div className="mainFooterDiv" tabIndex={0}>
                        <p className="fontfooter" onClick={() => {toggleList(2);
                            setval(false);
                            setval1(false);
                            setval2(false);
                            setval3(false);
                            setval5(false);

                            setval4(false);}} >{datafooter[2].headerfooter}  {activeIndex === 2 ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}</p>
                    </div>
                    <div className="mainFooterDiv designTab" tabIndex={0}>
                        <p className="fontfooter" onClick={() => {toggleList(3);
                            setval(false);
                            setval1(false);
                            setval2(false);
                            setval3(false);
                            setval5(false);

                            setval4(false);}} >{datafooter[3].headerfooter}  {activeIndex === 3 ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}</p>
                    </div>
                    <div className="mainFooterDiv designTab" tabIndex={0}>
                        <p className="fontfooter" onClick={() => {toggleList(4);
                            setval(false);
                            setval1(false);
                            setval2(false);
                            setval3(false);
                            setval5(false);

                            setval4(false);}} >{datafooter[4].headerfooter}  {activeIndex === 4 ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}</p>
                    </div>
                    <div className="mainFooterDiv designTab" tabIndex={0}>
                        <p className="fontfooter" onClick={() => {toggleList(5);
                            setval(false);
                            setval1(false);
                            setval2(false);
                            setval3(false);
                            setval5(false);

                            setval4(false);}} >{datafooter[5].headerfooter}  {activeIndex === 5 ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}</p>
                    </div>
                   
                    
                    {/* </Slider> */}
                    {/* <div className="mainFooterDiv designTab">
                        <h5 onClick={() => toggleList(6)} >{datafooter[6].headerfooter}  {activeIndex === 6 ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}</h5>
                    </div> */}
                </div>
                <div className="tabs-footer-data">
                    <div className="one">
                        {datafooter.map((item, index) => {
                            return (
                                <>
                                    <div>
                                        {activeIndex === index && (
                                            <div className="FooterAllLink tabFooter footerTabUpdated" key={index}>
                                               {/* footerTabUpdated updated */}
                                                    {activeIndex === 0 ?
                                                        <div className="stockDiv">
                                                            {/* first tab */}
                                                            {chunks.map((chunk, index) => (
                                                                <ul key={index} className="equityDiv">
                                                                    {chunk.map((item, itemIndex) => (
                                                                        <>
                                                                            <li>
                                                                                <a href={"/stocks/" + item.lname.replace(/ /g, '-').replace('&', 'and').replace('+', '').replace(/\./g, '')}
                                                                                    target="_blank" key={itemIndex}> {item.lname}</a>
                                                                            </li>
                                                                        </>
                                                                    ))}
                                                                </ul>
                                                            ))}
                                                        </div> :
                                                        <>
                                                        {val? <ul className="equityDiv footerEquity">
                                                        {item.submenufooter.map((i, m) => {
                                                            return (
                                                                <>
                                                                    <li key={1 + 1}>
                                                                        <a href={i.url}
                                                                            target="_blank"> {i.title} </a>
                                                                    </li>
                                                                </>
                                                            );
                                                        }
                                                        )}
                                                    </ul>: <ul className="equityDiv footerEquity">
                                                    {item.submenufooter.map((i, m) => {
                                                       if(m<=12){
                                                         return (
                                                             <>
                                                                 <li key={1 + 1}>
                                                                     <a href={i.url}
                                                                         target="_blank"> {i.title} </a>
                                                                 </li>
                                                        {m==12 ? <li><button className="footerReadMoreBtn" onClick={()=>setval(true)}>Read More</button></li> :null}
                                                             </>
                                                         );
                                                       }
                                                       
                                                    })}
                                                </ul>
                                                
                                                }
                                                        {val1? <ul className="equityDiv footerEquity">
                                                        {item.submenufooter1.map((i, m) => {
                                                            return (
                                                                <>
                                                                    <li key={1 + 1}>
                                                                        <a href={i.url}
                                                                            target="_blank"> {i.title} </a>
                                                                    </li>
                                                                </>
                                                            );
                                                        })}
                                                       </ul>: <ul className="equityDiv footerEquity">
                                                       {item.submenufooter1.map((i, m) => {
                                                          if(m<=12){
                                                            return (
                                                                <>
                                                                    <li key={1 + 1}>
                                                                        <a href={i.url}
                                                                            target="_blank"> {i.title} </a>
                                                                    </li>
                                                        {m==12 ?<li><button className="footerReadMoreBtn" onClick={()=>setval1(true)}>Read More</button></li> :null}
                                                                </>
                                                            );
                                                          }
                                                       })}
                                                   </ul>}
                                                   {val2? <ul className="equityDiv footerEquity">
                                                   {item.submenufooter2.map((i, m) => {
                                                       return (
                                                           <>
                                                               <li key={1 + 1}>
                                                                   <a href={i.url}
                                                                       target="_blank"> {i.title} </a>
                                                               </li>
                                                           </>
                                                       );
                                                   })}
                                               </ul>: <ul className="equityDiv footerEquity">
                                               {item.submenufooter2.map((i, m) => {
                                                  if(m<=12){
                                                    return (
                                                        <>
                                                            <li key={1 + 1}>
                                                                <a href={i.url}
                                                                    target="_blank"> {i.title} </a>
                                                            </li>
                                              {m==12 ?<li> <button className="footerReadMoreBtn" onClick={()=>setval2(true)}>Read More</button></li> :null}
                                                        </>
                                                    );
                                                  }
                                               })}
                                           </ul>}
                                           {val3? <ul className="equityDiv footerEquity">
                                           {item.submenufooter3.map((i, m) => {
                                               return (
                                                   <>
                                                       <li key={1 + 1}>
                                                           <a href={i.url}
                                                               target="_blank"> {i.title} </a>
                                                       </li>
                                                   </>
                                               );
                                           })}
                                       </ul>: <ul className="equityDiv footerEquity">
                                       {item.submenufooter3.map((i, m) => {
                                          if(m<=12){
                                            return (
                                                <>
                                                    <li key={1 + 1}>
                                                        <a href={i.url}
                                                            target="_blank"> {i.title} </a>
                                                    </li>
                                              {m==12 ? <li><button className="footerReadMoreBtn" onClick={()=>setval3(true)}>Read More</button></li> :null}

                                                </>
                                            );
                                          }
                                         
                                       })}
                                   </ul>}
                                   {val4? <ul className="equityDiv footerEquity">
                                   {item.submenufooter4.map((i, m) => {
                                       return (
                                           <>
                                               <li key={1 + 1}>
                                                   <a href={i.url}
                                                       target="_blank"> {i.title} </a>
                                               </li>
                                           </>
                                       );
                                   })}
                               </ul>: <ul className="equityDiv footerEquity">
                               {item.submenufooter4.map((i, m) => {
                                  if(m<=12){
                                    return (
                                        <>
                                            <li key={1 + 1}>
                                                <a href={i.url}
                                                    target="_blank"> {i.title} </a>
                                            </li>
                              {m==12 ?<li><button className="footerReadMoreBtn" onClick={()=>setval4(true)}>Read More</button></li> :null}
                                            
                                        </>
                                    );
                                  };
                                  
                                  
                               })
                               }
                           </ul>}
                                                            </>}
                                                
                                            </div>
                                        )}
                                    </div>
                                </>
                            );
                        })}
                    </div>
                </div>
            </div>


        </>

    );
};


export default TabFooter;